import dayjs from 'dayjs'

export const FORMATO_FECHA_ISO = 'YYYY-MM-DD'

export const formatearFecha = (valor, formato = 'DD/MM/YYYY') => {
  if (!valor) {
    return ''
  }
  const fecha = dayjs(valor)

  if (!fecha.isValid()) {
    return ''
  }

  return fecha.format(formato)
}

export const validarRangoFechas = (desdeValor, hastaValor, unidadComparacion = undefined) => {
  if (!desdeValor || !hastaValor) {
    return false
  }

  const fechaDesde = dayjs(desdeValor)
  const fechaHasta = dayjs(hastaValor)

  if (!fechaDesde.isValid() || !fechaHasta.isValid()) {
    return false
  }

  return !fechaHasta.isBefore(fechaDesde, unidadComparacion)
}

export const fechaEnRango = (fechaValor, desdeValor, hastaValor, incluirExtremos = false) => {
  if (!fechaValor || !desdeValor || !hastaValor) {
    return false
  }

  const fecha = dayjs(fechaValor)
  const fechaDesde = dayjs(desdeValor)
  const fechaHasta = dayjs(hastaValor)

  if (!fecha.isValid() || !fechaDesde.isValid() || !fechaHasta.isValid()) {
    return false
  }

  if (fechaDesde.isAfter(fechaHasta)) {
    return false
  }

  if (incluirExtremos) {
    return (
      fecha.isSame(fechaDesde) ||
      fecha.isSame(fechaHasta) ||
      (fecha.isAfter(fechaDesde) && fecha.isBefore(fechaHasta))
    )
  }

  return fecha.isAfter(fechaDesde) && fecha.isBefore(fechaHasta)
}

export const esFechaAnteriorAHoy = (fechaValor) => {
  if (!fechaValor) {
    return false
  }

  const fecha = dayjs(fechaValor)

  if (!fecha.isValid()) {
    return false
  }

  return fecha.startOf('day').isBefore(dayjs().startOf('day'))
}

export const calcularDiasHastaFecha = (fechaValor) => {
  if (!fechaValor) {
    return null
  }

  const fecha = dayjs(fechaValor)

  if (!fecha.isValid()) {
    return null
  }

  return fecha.startOf('day').diff(dayjs().startOf('day'), 'day')
}

export const fechaVenceEnDias = (fechaHastaValor, dias) => {
  if (!dias) {
    return false
  }

  return calcularDiasHastaFecha(fechaHastaValor) === dias
}

export const avisoProximoAVencer = (fechaValor, dias) => {
  const diasRestantes = calcularDiasHastaFecha(fechaValor)

  return diasRestantes !== null && diasRestantes >= 0 && diasRestantes <= dias
}

export const fechaOcurrioEnUltimosDias = (fechaValor, dias) => {
  if (!fechaValor || dias < 0) {
    return false
  }

  const fecha = dayjs(fechaValor)

  if (!fecha.isValid()) {
    return false
  }

  const diasTranscurridos = dayjs().startOf('day').diff(fecha.startOf('day'), 'day')
  return diasTranscurridos >= 0 && diasTranscurridos <= dias
}

export const obtenerFechaInicioMesSiguiente = (formato = 'DD/MM/YYYY') =>
  dayjs().add(1, 'month').startOf('month').format(formato)

export const textoTiempoHastaFecha = (fechaValor) => {
  const dias = calcularDiasHastaFecha(fechaValor)

  if (dias === null) {
    return ''
  }

  if (dias >= 1) {
    return `${dias} ${dias === 1 ? 'día' : 'días'}`
  }

  const horas = dayjs(fechaValor).diff(dayjs(), 'hour')

  if (horas >= 1) {
    return `${horas} ${horas === 1 ? 'hora' : 'horas'}`
  }

  const minutos = dayjs(fechaValor).diff(dayjs(), 'minute')

  return `${minutos} ${minutos === 1 ? 'minuto' : 'minutos'}`
}
